<template>
    <div>
        <employeeHourlyAnnual-leave-list></employeeHourlyAnnual-leave-list>
    </div>
    </template>
    <script>
    export default {}
    </script>
    